import moment from 'moment'

const isValidCsvDate = value =>
  typeof value === 'string' &&
  moment(value, ['YYYY-MM-DD', 'YYYY/MM/DD'], true).isValid()

export default isValidCsvDate
